/**
 * Genesis Sample entry point.
 *
 * @package GenesisSample\JS
 * @author  StudioPress
 * @license GPL-2.0+
 */

var genesisSample = (function ($) {
  "use strict";

  /**
   * Adjust site inner margin top to compensate for sticky header height.
   *
   * @since 2.6.0
   */
  var moveContentBelowFixedHeader = function () {
      var siteInnerMarginTop = 0;

      if (jQuery(".site-header").css("position") === "fixed") {
        siteInnerMarginTop = jQuery(".site-header").outerHeight();
      }

      jQuery(".site-inner").css("margin-top", siteInnerMarginTop);
    },
    /**
     * Initialize Genesis Sample.
     *
     * Internal functions to execute on document load can be called here.
     *
     * @since 2.6.0
     */
    init = function () {
      // Run on first load.
      moveContentBelowFixedHeader();

      // Run after window resize.
      jQuery(window).resize(function () {
        moveContentBelowFixedHeader();
      });

      // Run after the Customizer updates.
      // 1.5s delay is to allow logo area reflow.
      if (typeof wp.customize != "undefined") {
        wp.customize.bind("change", function (setting) {
          setTimeout(function () {
            moveContentBelowFixedHeader();
          }, 1500);
        });
      }
    };

  // Expose the init function only.
  return {
    init: init,
  };
})(jQuery);

export function init() {
  genesisSample.init;
}
